import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getContainerPlatformTypes(context) {
      const response = await Vue.axios.get(`${URL_API}containerplatformtype`);
      let data = response["data"];
      context.commit("updateContainerPlatformTypes", data);
    },
    async createContainerPlatformType(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}containerplatformtype/store`, body, config);
      context.dispatch("getContainerPlatformTypes");
    },
    async pushContainerPlatformType(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}containerplatformtype/update`, body, config);
      context.dispatch("getContainerPlatformTypes");
    },
    async destroyContainerPlatformType(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}containerplatformtype/destroy`, body, config);
      context.dispatch("getContainerPlatformTypes");
    }
  },
  mutations: {
    updateContainerPlatformTypes(state, containerPlatformTypes) {
      state.containerPlatformTypes = containerPlatformTypes;
    }
  },
  state: {
    containerPlatformTypes: []
  },
  getters: {
    allContainerPlatformTypes(state) {
      return state.containerPlatformTypes;
    }
  }
};